import { ref, readonly } from 'vue'

import type { ComponentNode } from '@canvas-builder/types/canvas'
import type { CanvasRetrieve } from '@openapi'

const clickedOnSection = ref<{ sectionListId: ComponentNode['id']; sectionId: CanvasRetrieve['id'] }>()

function resetClickedOnSection() {
  clickedOnSection.value = undefined
}

function setClickedOnSection(sectionListId: ComponentNode['id'], sectionId: CanvasRetrieve['id']) {
  clickedOnSection.value = { sectionListId, sectionId }
}

export default function useCanvasTheme() {
  return {
    clickedOnSection: readonly(clickedOnSection),
    resetClickedOnSection,
    setClickedOnSection,
  }
}
